module.exports = __webpack_public_path__ + "static/img/code2.0fa9847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code2.png
// module id = IpC8
// module chunks = 0